import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError, first } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { User, UserSearchFilter } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<User[]>(`${environment.apiUrl}/users`);
    }

    getBy(id) {
        return this.http.get<any>(`${environment.apiUrl}/users/profile/${id}`);
    }

    search(filter: UserSearchFilter) {
        return this.http.post(`${environment.apiUrl}/users/search`, filter);
    }

    update(updatedUser: any) {
        return this.http.put(`${environment.apiUrl}/users/profile/${updatedUser.userId}`, updatedUser);
    }

    setMailUpdates(userId: any, receiveMailUpdates: boolean) {
        return this.http.post<any>(`${environment.apiUrl}/users/${userId}/mailupdates`, 
        {
            ReceiveMailUpdates: receiveMailUpdates
        })
        .pipe(map(result => {
            return result;
        }), catchError( er => {
            console.log("error  " + er);
            return er;
        }));
    }

    setUserSearchConsent(userId: any, searchConsent: boolean) {
        return this.http.patch<any>(`${environment.apiUrl}/users/${userId}/searchconsent`, 
        {
            SearchConsent: searchConsent
        })
        .pipe(map(result => {
            return result;
        }), catchError( er => {
            console.log("error  " + er);
            return er;
        }));
    }

    finishOnboarding(userId: any) {
        return this.http.post<any>(`${environment.apiUrl}/users/${userId}/finishonboarding`, null)
        .pipe(map(result => {
            return result;
        }), catchError( er => {
            console.log("error  " + er);
            return er;
        }));
    }

     addCompanyZipCodes(userId : any, selectedZipCodes: any[]) {
        return this.http.post<any>(`${environment.apiUrl}/users/${userId}/addlocations`, {
            LocationIds: selectedZipCodes.map(x => x.zipCode)
        })
        .pipe(map(result => {
            return result;
        }), catchError( er => {
            console.log("error  " + er);
            return er;
        }));
    }

    markConnectToSlackStepAsComplete(userId : any) {
        return this.http.post<any>(`${environment.apiUrl}/users/${userId}/connect-to-slack-step`, null);
    }

    getMailSubscriptionStatus() {
        return this.http.get<any>(`${environment.apiUrl}/users/my/mail-subscription-status`);
    }
}